/**
 * Compares each element in two arrays.  True if each element is the same.
 * @param array1 
 * @param array2 
 * @returns array1 and array2 are the same length and each element is the same
 */
export function arrayCompare<T>(array1: T[], array2: T[]): boolean {
    return array1.length === array2.length
        && array1.every((value, index) => value === array2[index]);
}

/**
 * Returns a random integer.
 * From https://www.w3schools.com/JS/js_random.asp .
 * @param min min
 * @param max max
 * @returns a random number between min (inclusive) and max (inclusive)
 */
export function getRndInteger(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Generates a range of numbers.
 * Source: https://www.technicalfeeder.com/2021/07/how-to-generate-number-range-array-int-and-float/ .
 * @param start 
 * @param end 
 */
export function range(start: number, end: number): number[] {
    return Array.from(
        Array(end - start + 1).keys()
    ).map(x => x + start);
}

/**
 * Shuffles an array.
 * See https://stackoverflow.com/a/2450976/1260011 .
 * @param array 
 * @returns a shuffled array
 */
export function shuffle<T>(array: T[]): T[] {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
}